import React from "react";
import PropTypes from "prop-types";
import { PictureCover } from "globalStyles/Containers";
import AddIcon from "components/Icons/AddIcon";
import {
  PhotoLabel,
  IconWrapper,
  PlaceholderContainer
} from "../PicturesLoadedStyled";
import { useTranslate } from "hooks/translation-hooks";

const PlaceHolderBox = ({ uploadPictures, index }) => {
  const t = useTranslate();
  return (
    <PictureCover onClick={uploadPictures} data-testid={`image-loaded${index}`}>
      <PlaceholderContainer>
        <IconWrapper>
          <AddIcon />
        </IconWrapper>
        <PhotoLabel>{t("photos_placeholder-add_photo")}</PhotoLabel>
      </PlaceholderContainer>
    </PictureCover>
  );
};

PlaceHolderBox.propTypes = {
  uploadPictures: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

export default PlaceHolderBox;
